module.exports = __webpack_public_path__ + "static/media/lamina16dialogo.6418ca68.png";